import { Component, Vue, Prop } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { createPopper } from '@popperjs/core';
import './style.styl';

@Component({
  name: 'Tooltip',
})
export default class Tooltip extends Vue {
  @Prop({type: String, default: ''}) public readonly target!: string;

  public tooltip;

  public get reference(): Element {
    let ref;
    if (this.target) {
      ref = this.$el.querySelector(this.target);
    }
    return ref ? ref : this.$refs.target;
  }

  public createTooltip() {
    this.tooltip = createPopper(this.reference, this.$refs.content as HTMLElement, {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [10, 10],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom'],
            allowedAutoPlacements: ['top', 'bottom'],
          },
        },
      ],
    });
  }

  public showTooltip(el) {
    el.setAttribute('data-show', '');
    // trick for update tooltip position
    this.tooltip.forceUpdate();
  }

  public hideTooltip(el) {
    el.removeAttribute('data-show');
    // trick for update tooltip position
    this.tooltip.forceUpdate();
  }

  public mounted() {
    if (!!this.$children.length) {
      this.createTooltip();
    }
  }

  public updated() {
    if (!this.$children.length) {
      this.createTooltip();
    }
  }

  public render(createElement: CreateElement): VNode {

    const target: VNode = createElement('div', {
      ref: 'target',
      attrs: {
        'aria-describedby': 'tooltip',
      },
      class: 'tooltip-target',
      on: {
        mouseenter: () => this.showTooltip(this.$refs.content),
        focus: () => this.showTooltip(this.$refs.content),
        mouseleave: () => this.hideTooltip(this.$refs.content),
        blur: () => this.hideTooltip(this.$refs.content),
      },
  }, [this.$slots.target]);

    const tooltip: VNode = createElement('div', {
      ref: 'content',
      class: 'tooltip-content',
      attrs: {
        role: 'tooltip',
      },
    }, [this.$slots.content,
      createElement('div', { attrs: { 'data-popper-arrow': '' }, class: 'tooltip-arrow' }),
    ]);

    return createElement('span', {style: 'position: relative'}, [target, tooltip]);
  }
}
